/* eslint-disable @typescript-eslint/no-explicit-any */
import { logUserEvent } from '@analytics/amplifyLogging';
import { useHomeContext } from '@components_v2/context/MyHomeContext';
import {
    AccordionBase,
    AccordionDetailsBase,
    AccordionSummaryBase,
    ButtonBase,
    LinkBase,
    StackBase,
    TypographyBase
} from '@fmc-digital/ui';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LogoutIcon from '@mui/icons-material/Logout';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import MenuIcon from '@mui/icons-material/Menu';
import {
    ClickAwayListener,
    Drawer,
    Grow,
    IconButton,
    ListItem,
    ListItemText,
    MenuItem,
    MenuList,
    Paper,
    Popper,
    useMediaQuery,
    useTheme
} from '@mui/material';
import Box from '@mui/material/Box';
import { RootState } from '@store';
import { logOutAction } from '@store/actions/logout.actions';
import { selectAllowedPortcodesForMessageCentre, selectFeatureFlag } from '@store/reducers/config.reducer';
import { selectUserProfile } from '@store/selectors/widgets.selectors';
import { useQueryClient } from '@tanstack/react-query';
import { NavigationOptions } from '@types';
import { clearCookie } from '@utils/cookieHelper';
import { getIntials } from '@utils/getIntials';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth, config } from '../../../../config';
import { FreedomWhiteIcon, HamburgerMenuUnreadIcon } from '../icons';
import Profile from '../profile/Profile';
import { isEmpty } from 'lodash';
import { filterDisableMenuOption } from '@utils/disableMenuOptions';
import { selectUserInfo } from '@store/selectors/widgets.selectors';

export const MobileHeaderLayout = ({
    firstName,
    lastName,
    mainMenuOptions,
    isServicing,
    logoClickHandler,
    selectedLoanNumber,
    onHeaderClickHandler
}: any) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const [showMessagecentre, setShowMessageCentre] = useState(false);
    const portCode = useSelector(selectUserInfo).portCode;
    const mcPortCodes = useSelector(selectAllowedPortcodesForMessageCentre);
    const [open, setOpen] = React.useState(false);
    const [menuOpen, setMenuOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    // const anchorRef = React.useRef<HTMLButtonElement | null>(null);
    const userProfile: NavigationOptions = useSelector(selectUserProfile);
    const context = useHomeContext();
    const client = useQueryClient();
    const navigate = useNavigate();
    const location = useLocation();
    const { onLogoutEvent } = useHomeContext();
    const isMCFeatureFlagEnabled = useSelector((state: RootState) => selectFeatureFlag(state, 'messageCenter'));
    const unreadCount = useSelector((state: RootState) => state.unreadCount.unreadCount);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setExpanded(false);
        setOpen(false);
        // Getting error on dispatch action
        //  dispatch(logOutAction());
    };

    const [expanded, setExpanded] = React.useState<string | false>('');

    const handleChange = (panel: string) => (_: any, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false);
    };
    useEffect(() => {
        if (isMCFeatureFlagEnabled) {
            if (mcPortCodes.length === 0) {
                setShowMessageCentre(true);
            }
            mcPortCodes.map(port => {
                if (String(port) === portCode) {
                    setShowMessageCentre(true);
                }
            });
        }
    }, [isMCFeatureFlagEnabled, mcPortCodes, portCode]);

    const handleToggle = async (name: string) => {
        if (onHeaderClickHandler) onHeaderClickHandler(name);
        if (name === 'Log Out') {
            client.clear();
            client.removeQueries();
            onLogoutEvent();
            dispatch(logOutAction());
            await auth.getOkta().signOut();
            auth.getOkta().tokenManager.clear();
            clearCookie();
        }
        setExpanded(false);
        setOpen(false);
    };

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
        setMenuOpen(previousOpen => !previousOpen);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setMenuOpen(false);
    };

    const handleClose = (event: Event | React.SyntheticEvent, option: NavigationOptions | undefined = undefined) => {
        if (!isEmpty(anchorEl) && anchorEl.contains(event.target as HTMLElement)) {
            return;
        }
        if (option) {
            switch (option.id) {
                case 'user_profile_url':
                    clearCookie();
                    auth.getOkta().tokenManager.clear();
                    window.location.replace(`${userProfile.url}?${window.btoa(config.env('redirectUri'))}`);
                    break;
                case 'hardship_assistance_url':
                    window.open(option.url, '_blank');
                    break;
                case 'Escrow Assessment':
                    break;
                case 'payoff_wire_transfer_url':
                    window.open(option.url, '_blank');
                    break;
                case 'FAQs':
                    window.open(option.url, '_blank');
                    break;
                case 'disaster_assistance_url':
                    logUserEvent({
                        action: 'DisasterAssistanceClicked',
                        type: 'Support',
                        description: 'Disaster Assistance Clicked'
                    });
                    navigate('disaster-assistance');
                    break;
                case 'manage_account_sso_url':
                    context.accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost`).catch(console.log);
                    break;
                case 'account_details_sso_url':
                    context.accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost`).catch(console.log);
                    break;
                case 'recurring_payment_sso_url':
                    context
                        .accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost?target_menu=recurringPayments`)
                        .catch(console.log);
                    break;
                case 'payment_history_sso_url':
                    context
                        .accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost?target_menu=paymentHistory`)
                        .catch(console.log);
                    break;
                case 'all_documents_sso_url':
                    context
                        .accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost?target_menu=statements`)
                        .catch(console.log);
                    break;
                case 'pay_now_sso_url':
                    context
                        .accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost?target_menu=oneTimePayment`)
                        .catch(console.log);
                    break;
                default:
                    break;
            }
        }
        setExpanded(false);
        setOpen(false);
    };
    const onMCButtonClick = () => {
        logUserEvent({
            type: 'Message Center',
            description: 'Customer clicked Message Center Icon',
            action: 'MessageCenterIconClicked'
        });
        setExpanded(false);
        setOpen(false);
        navigate('/mc', { state: { from: location } });
    };
    const isMobile = useMediaQuery(theme.breakpoints.only('xs'));

    React.useEffect(() => {
        return () => {
            setExpanded(false);
            setOpen(false);
        };
    }, []);

    const profileOption = mainMenuOptions.find((item: any) => item?.id === 'Profile');
    const canBeOpen = open && Boolean(anchorEl);
    const idPopper = canBeOpen ? 'transition-popper' : undefined;

    return (
        <StackBase
            direction="row"
            justifyContent="space-between"
            sx={_theme => ({
                padding: { xs: '0.5rem 1rem', sm: '0.5rem 2rem' },
                background: theme.palette.surfaceDark.main,
                borderBottom: `4px solid ${_theme.palette.teal.main}`
            })}
        >
            <IconButton color="inherit" aria-label="open drawer" onClick={handleDrawerOpen} sx={{ padding: '0' }}>
                {unreadCount > 0 ? (
                    <HamburgerMenuUnreadIcon sx={{ width: 36, height: 36, color: theme.palette.surface.contrastText }} />
                ) : (
                    <MenuIcon sx={{ width: 36, height: 36, color: theme.palette.surface.contrastText }} />
                )}
            </IconButton>
            <Box display={'flex'} justifyContent={'center'} width={'100%'} alignItems="center" paddingRight="2.25rem">
                <IconButton onClick={logoClickHandler} disableRipple sx={{ padding: '0' }}>
                    <FreedomWhiteIcon sx={{ width: '106.253px', height: '32px' }} />
                </IconButton>
            </Box>
            <Drawer
                PaperProps={{
                    sx: {
                        background: theme.palette.surfaceDark.main,
                        padding: '2rem',
                        width: isMobile ? '100%' : '50%'
                    }
                }}
                anchor="left"
                open={open}
            >
                <StackBase direction="row" justifyContent="space-between" alignItems="flex-start">
                    <IconButton aria-label="close drawer" onClick={handleDrawerClose} sx={{ padding: '0' }}>
                        <CloseIcon sx={{ color: 'white' }} />
                    </IconButton>
                    <TypographyBase
                        aria-describedby={idPopper}
                        onClick={handleClick}
                        sx={{ background: 'transparent', padding: 0 }}
                        id="Profile"
                    >
                        <Profile name={getIntials(`${firstName} ${lastName}`)} />
                    </TypographyBase>
                    <Popper
                        id={idPopper}
                        open={menuOpen}
                        placement="bottom-start"
                        anchorEl={anchorEl}
                        transition
                        disablePortal
                        sx={{ zIndex: 1 }}
                    >
                        {({ TransitionProps }) => (
                            <Grow {...TransitionProps}>
                                <Paper
                                    sx={{
                                        background: '#12202c',
                                        color: '#6ED8FF',
                                        padding: theme.spacing(2),
                                        borderRadius: theme.spacing(1),
                                        marginTop: '0.375rem',
                                        borderTopRightRadius: '0'
                                    }}
                                >
                                    <ClickAwayListener onClickAway={handleMenuClose}>
                                        <MenuList
                                            autoFocusItem={open}
                                            id="composition-menu"
                                            aria-labelledby="composition-button"
                                            disablePadding={true}
                                        >
                                            {profileOption?.subMenuOptions.map((option: NavigationOptions, idx: any) => {
                                                return (
                                                    <MenuItem
                                                        onClick={event => handleClose(event, option)}
                                                        key={`${idx}_menu_item`}
                                                        sx={{
                                                            minHeight: 'unset',
                                                            padding: '0.5rem 1rem',
                                                            '&:hover': {
                                                                backgroundColor: 'unset'
                                                            },
                                                            '&:not(:last-child)': {
                                                                marginBottom: '0.5rem'
                                                            }
                                                        }}
                                                    >
                                                        <ListItemText
                                                            key={`${idx}_list_item`}
                                                            primary={
                                                                <TypographyBase variant="btn-label" color="secondary.main">
                                                                    {option.name}
                                                                </TypographyBase>
                                                            }
                                                        />
                                                    </MenuItem>
                                                );
                                            })}
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </StackBase>

                <StackBase marginTop={'4rem'} flex={1} gap="1rem">
                    {mainMenuOptions.map((menu: any) => {
                        if (
                            !isServicing &&
                            ['Loan_Information', 'Payment_Center', 'Document', 'Message_Center'].some(_id => _id === menu.id)
                        )
                            return null;

                        return (
                            menu?.name !== 'Profile' &&
                            menu?.name !== 'Log Out' &&
                            (menu?.id === 'Message_Center' ? (
                                isMCFeatureFlagEnabled && showMessagecentre ? (
                                    <StackBase
                                        direction="row"
                                        onClick={onMCButtonClick}
                                        sx={{
                                            cursor: 'pointer',
                                            '&:hover span': {
                                                fontWeight: 500,
                                                fontFamily: 'Poppins-Medium'
                                            }
                                        }}
                                        gap="0.5rem"
                                        data-testid="mcMenuElement"
                                        id={menu?.id}
                                    >
                                        <MailOutlineIcon sx={{ fontSize: '1.5rem', color: 'primary.contrastText', cursor: 'pointer' }} />
                                        <TypographyBase variant="paragraph" color="primary.contrastText">
                                            Messages
                                        </TypographyBase>
                                    </StackBase>
                                ) : null
                            ) : (
                                <AccordionBase
                                    expanded={expanded === menu?.name}
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    onChange={handleChange(menu?.name)}
                                    elevation={0}
                                    sx={{
                                        backgroundColor: 'unset',
                                        position: 'unset',
                                        '&.Mui-expanded': {
                                            margin: '0'
                                        },
                                        '&:hover .MuiAccordionSummary-content span': {
                                            fontWeight: 500,
                                            fontFamily: 'Poppins-Medium'
                                        }
                                    }}
                                    id={menu?.id}
                                >
                                    <AccordionSummaryBase
                                        expandIcon={
                                            expanded === menu?.name ? (
                                                <StackBase sx={{ color: '#35CCBA' }}>
                                                    <ExpandMoreIcon />{' '}
                                                </StackBase>
                                            ) : (
                                                <StackBase sx={{ color: '#35CCBA' }}>
                                                    <ExpandMoreIcon />{' '}
                                                </StackBase>
                                            )
                                        }
                                        sx={{
                                            padding: '0',
                                            minHeight: 'unset',
                                            '&.Mui-expanded': {
                                                minHeight: 'unset'
                                            },
                                            '& .MuiAccordionSummary-content, & .Mui-expanded.MuiAccordionSummary-content': {
                                                margin: '0'
                                            }
                                        }}
                                    >
                                        <TypographyBase
                                            color={expanded === menu?.name ? 'teal.main' : 'surface.contrastText'}
                                            variant={expanded === menu.name ? 'paragraph-bold' : 'paragraph'}
                                        >
                                            {menu?.name}
                                        </TypographyBase>
                                    </AccordionSummaryBase>

                                    <AccordionDetailsBase sx={{ padding: '1rem 0 0 0' }}>
                                        <StackBase justifyContent={'flex-start'} alignItems={'flex-start'} width="100%">
                                            {menu?.subMenuOptions?.map((item: any, index: number) => {
                                                // if (item?.id === 'logout_url') setUrl(item?.url);
                                                return (
                                                    <StackBase
                                                        sx={{
                                                            color: '#6ED8FF'
                                                        }}
                                                        key={`${index}`}
                                                        width="100%"
                                                    >
                                                        <ListItem key={`${item}-${index}`}>
                                                            <ListItemText
                                                                sx={{
                                                                    cursor: 'pointer',
                                                                    margin: '0',
                                                                    flexGrow: '1',
                                                                    pointerEvents: filterDisableMenuOption(item, selectedLoanNumber)
                                                                        ? 'none'
                                                                        : 'auto'
                                                                }}
                                                                onClick={event => {
                                                                    if (item.id === 'call_at') return;
                                                                    handleClose(event, item);
                                                                }}
                                                            >
                                                                {item.id === 'call_at' ? (
                                                                    <LinkBase href={`tel:${item.url}`} underline="none">
                                                                        <TypographyBase variant="paragraph-bold" color="secondary.main">
                                                                            {item?.name}
                                                                        </TypographyBase>
                                                                    </LinkBase>
                                                                ) : (
                                                                    <TypographyBase
                                                                        variant="paragraph-bold"
                                                                        color={
                                                                            filterDisableMenuOption(item, selectedLoanNumber)
                                                                                ? 'disabled.main'
                                                                                : 'secondary.main'
                                                                        }
                                                                    >
                                                                        {item?.name}
                                                                    </TypographyBase>
                                                                )}
                                                            </ListItemText>
                                                        </ListItem>
                                                    </StackBase>
                                                );
                                            })}
                                        </StackBase>
                                    </AccordionDetailsBase>
                                </AccordionBase>
                            ))
                        );
                    })}
                </StackBase>
                <StackBase
                    direction="row"
                    alignItems="center"
                    gap="0.125rem"
                    padding="0.375rem 0.5rem"
                    sx={{ cursor: 'pointer' }}
                    onClick={() => handleToggle('Log Out')}
                    id="logout_url"
                >
                    <LogoutIcon sx={{ fontSize: '1rem', color: 'surface.contrastText' }} />
                    <TypographyBase variant="caption-bold" color="surface.contrastText">
                        Logout
                    </TypographyBase>
                </StackBase>
            </Drawer>
        </StackBase>
    );
};
